module.exports = __webpack_public_path__ + "pcstatic/img/logo_1.bf18efc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_1.png
// module id = Cz8E
// module chunks = 2